import "./Blog.css";
import React, { useState, useEffect } from "react";

const PAGE_SIZE = 6;

const EXTRA_TITLES = [
  "[KBS 1 TV] AI토피아 유튜브 출연! - AI가 관리하는 내 연금",
];

function formatDate(isoDate) {
  const d = new Date(isoDate);
  if (isNaN(d)) return isoDate;
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
}

function Blog() {
  const [allPosts, setAllPosts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/posts.json")
      .then((r) => r.json())
      .then((posts) => {
        const seen = new Set();
        const result = [];
        posts.forEach((post) => {
          const title = post.title || "";
          if (seen.has(title)) return;
          const isFinanceAI = (post.categories || []).some((c) => c.includes("금융 AI"));
          const isExtra = EXTRA_TITLES.some((t) => title.includes(t) || t.includes(title));
          if (isFinanceAI || isExtra) {
            seen.add(title);
            result.push({ ...post, date: formatDate(post.date) });
          }
        });
        setAllPosts(result);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (!loading && allPosts.length === 0) return null;

  const visiblePosts = allPosts.slice(0, visibleCount);
  const hasMore = visibleCount < allPosts.length;

  return (
    <div className="blog_container">
      <div className="blog_title_container">
        <div className="blog_title">Blog</div>
      </div>
      {loading ? (
        <div className="blog_loading">불러오는 중...</div>
      ) : (
        <div className="container-xxl">
          <div className="blog_grid">
            {visiblePosts.map((post, i) => (
              <a
                key={i}
                className="blog_card"
                href={post.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="blog_card_image">
                  {post.image ? (
                    <img src={post.image} alt={post.title} />
                  ) : (
                    <div className="blog_card_placeholder">
                      <span>Blog</span>
                    </div>
                  )}
                </div>
                <div className="blog_card_content">
                  <p className="blog_card_date">{post.date}</p>
                  <h6 className="blog_card_title">{post.title}</h6>
                  <p className="blog_card_summary">{post.summary}</p>
                  <span className="blog_card_btn">자세히 보기</span>
                </div>
              </a>
            ))}
          </div>
          {hasMore && (
            <div className="blog_more_wrap">
              <button
                className="blog_more_btn"
                onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}
              >
                더 보기 ({allPosts.length - visibleCount}개 남음)
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Blog;
